import React, { useEffect, useRef, useState } from "react";
import KnowAsServiceHeader from "../component/KnowAsServiceHeader";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";
import Images from "../assets/Image";
import ContactUsFooter from "../component/ContactUsFooter";

export default function KnowAs() {
  const visionMissionRef = useRef(null);
  const [visionMissionCard, setVisionMissionCard] = useState(false);
  const makeUsDifferentCard = [
    {
      image: Images?.knowUsBulb,
      header: "Innovative",
      content:
        "We have creative developers with hands of experience in a designing and development industry. They are handling all the latest platforms",
    },
    {
      image: Images?.knowUsGoldBag,
      header: "Cost Effective",
      content:
        "We understand the current economic market scenario and that’s why we always strive to offer a most cost effective solution to your requirements.",
    },
    {
      image: Images?.knowUsEarthVan,
      header: "Timely Delivery",
      content:
        "We have a great supporting team to care our customers. They are is ready to providing 24/7 support.",
    },
  ];
  const branchDetails = [
    {
      image: Images?.bangaloreIcon,
      name: "BANGALORE",
    },
    {
      image: Images?.bhubaneshwarIcon,
      name: "BHUBANESWAR",
    },
    {
      image: Images?.chennaiIcon,
      name: "CHENNAI",
    },
    {
      image: Images?.ghaziabadIcon,
      name: "GHAZIABAD",
    },
    {
      image: Images?.goaIcon,
      name: "GOA",
    },
    {
      image: Images?.hosurIcon,
      name: "HOSUR",
    },
    {
      image: Images?.HYDERABADIcon,
      name: "HYDERABAD",
    },
    {
      image: Images?.MumbaiIcon,
      name: "MUMBAI",
    },
    {
      image: Images?.PUDUCHERRYIcon,
      name: "PUDUCHERRY",
    },
    {
      image: Images?.VijayawadaIcon,
      name: "VIJAYAWADA",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisionMissionCard(true);
          observer.disconnect(); // Run only once
        }
      },
      { threshold: 0.6 },
    );

    if (visionMissionRef.current) observer.observe(visionMissionRef.current);
  }, []);
  return (
    <div>
      <Navbar />
      <KnowAsServiceHeader content="Know Us" />
      <div className="knowAsMainContainer">
        <div className="qualityProductTxtContainer">
          {/* <h2 className="knowAsPageHeaderTxt">Know Us</h2> */}
          <div className="knowAsContentHeader">
            <i>“We Use Best Quality Products for Our Smoothies”</i>
          </div>
          <div className="knowUsTxtContainer">
            <div className="knowUsTxtLeftContainer">
              <p className="knowUsQualityProductTxt">
                The journey of a thousand miles begins with a single step… Mr.
                Joseph established USP in the year 2005, with the objective of
                introducing technology‐driven solutions in the packaging
                industry. Much like the packaging industry that has evolved with
                newer printers that offer better quality and cost‐effectiveness,
                USP has grown steadily over the years to become a market
                leader today.
              </p>
              <p className="knowUsQualityProductTxt">
                Our team continually scans the markets for printers, consumables
                and other packaging solutions to identify the best products that
                can be made available and be utilized to fulfill the
                requirements of our customers, so that use the latest
                technological trends and methodologies can be deployed
                to leverage desired results, to the complete satisfaction of our
                customers.
              </p>
              <p className="knowUsQualityProductTxt">
                The resilience of team USP in its dauntless approach to
                challenges and in overcoming many an obstacle has piloted the
                company and brand to the heights of success no wonder, then, we
                have become the choice packaging solutions partner for some of
                the top global brands in the market.
              </p>
              <p className="knowUsQualityProductTxt">
                Our endeavors and work spirit stems from core business values,
                honesty, integrity and a no compromise attitude in ensuring the
                very best for the customer precisely, the result of performance
                meeting or exceeding expectation!
              </p>
            </div>
            <div className="knowUsTxtRightContainer">
              <img
                className="knowUsTxtRightImg"
                src={Images?.knowUsQualityProduct}
                alt="knowUsTxtLeftContainer"
              />
            </div>
          </div>
        </div>
        <div className="cardContainer my-3">
          <div
            className={`card ${visionMissionCard ? "animate" : ""}`}
            ref={visionMissionRef}
          >
            <div className="cardHeaderImg">
              <img
                className="cardImg"
                src={Images?.homePageVisionCard}
                alt="homePageVisionCard"
              />
              <div className="imgBlurOverlay"></div>
              <div className="sharpOverlay leftPanel"></div>
              <div className="sharpOverlay rightPanel"></div>
            </div>
            <div className="cardTxt">
              <div className="cardTxtHeader">VISION</div>
              <div className="cardTxtData">
                To be recognised as a world leader in the industry of packaging
                solutions by providing high quality products and services to all
                our clients in a timely manner. We envision USP as a brand that
                every industry recognises and desire to partner with for their
                company's packaging solutions.
              </div>
            </div>
          </div>
          <div className={`card ${visionMissionCard ? "animate" : ""}`}>
            <div className="cardHeaderImg">
              <img
                className="cardImg"
                src={Images?.homePageMissionCard}
                alt="homePageVisionCard"
              />
              <div className="imgBlurOverlay"></div>
              <div className="sharpOverlay leftPanel"></div>
              <div className="sharpOverlay rightPanel"></div>
            </div>
            <div className="cardTxt">
              <div className="cardTxtHeader">MISSION</div>
              <div className="cardTxtData">
                To identify the latest technological trends and methodologies
                which are being utilised in the packaging industry and to
                provide our clients with such solutions that keep them ahead in
                their industry. In doing so, we aim at enhancing the overall
                productivity and success of our clients which will fuel our own
                desire to achieve.
              </div>
            </div>
          </div>
        </div>

        <div className="makesUsDifferentContainer">
          <div className="makesUsDifferentHeaderContainer">
            <div className="makesUsDifferentMainHeader">
              What Makes Us Different
            </div>
            <div className="makesUsDifferentSubHeader">We Are Really Good</div>
          </div>
          <div className="makeUsDifferentCardMainContainer">
            {makeUsDifferentCard?.map((items, index) => {
              return (
                <div className="makesUsDifferentCard">
                  <div className="makeUsDifferentImg py-2">
                    <img className="" src={items?.image} alt="knowUsBulb" />
                  </div>
                  <div>
                    <div className="cardTxtHeader text-center">
                      {items?.header}
                    </div>
                    <div className="cardTxtData text-justify">
                      {items?.content}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="knowUsFounderMainContainer">
          <div className="knowUsFounderInnerContainer">
            <div className="knowUsFounderImgContainer">
              <div className="knowUsFounderImg"></div>
              <div className="knowUsFounderNameContainer">
                <div className="knowUsFounderName">Mr. Joseph</div>
                <div className="knowUsFounderDetails">
                  Founder - USP Packaging Solutions Pvt Ltd
                </div>
              </div>
            </div>
            <div className="knowAsFounderContent">
              <div className="knowUsQualityProductTxt">
                In an era of hot-foil stamping and self-adhesive stickers, he
                relentlessly pitched in the advantages of non-contact industrial
                inkjet coding. His subsequent success in selling the idea of
                inkjet printing as a method of printing variable information led
                to a major change in the packaging and printing industry.
              </div>
              <div className="knowUsQualityProductTxt">
                1987 – He began his career in the sales and marketing industry.
              </div>
              <div className="knowUsQualityProductTxt">
                1989 – He climbed the ladder of success quickly to become the
                Divisional Manager in Domino Inkjet Printing Division, New Delhi
                with Bradma.{" "}
              </div>
              <div className="knowUsQualityProductTxt">
                1996 – He became the Regional Manager with Domino Printech,
                Kolkata (The organization was a newly-formed subsidiary of
                Domino Printing Sciences plc, UK).
              </div>
              <div className="knowUsQualityProductTxt">
                1998 – Going up another notch, he moved up as Head Marketing –
                Packaging Machinery Division for Flex Industries, a 1000-crore
                group.
              </div>
              <div className="knowUsQualityProductTxt">
                In the course of his professional career,  he worked closely
                with the policy-making bodies of the country like the Bureau of
                Indian Standards and The Weights and Measures Department of
                India. He assisted in the formation of important legislation
                that dictate the packaging and coding procedures in industries
                of the country today. He is also known for supporting the need
                for eliminating stickers which print the manufacture and expiry
                dates. Other areas where his work is recognized include his
                vociferous campaign for the need to ban the sale of loose oil
                fore‐fronted by the Edible Oil Awareness Campaign.
              </div>
              <div className="knowUsQualityProductTxt">
                He built USP on the values of honesty and integrity ensuring
                that the employees are in friendly work environment and he
                understood the importance of these values. He continues to
                inspire the employees everyday with his endless passion for
                work.
              </div>
            </div>
          </div>
        </div>

        <div className="knowUsBranch">
          <div className="branchHeader">OUR BRANCHES</div>
          <div className="flex justify-center">
            <div className="branchImgMainContainer">
              {branchDetails?.map((item, index) => {
                return (
                  <div className="branchImgContainer">
                    <div className="branchImg">
                      <img src={item?.image} alt="chennaiIcon" />
                    </div>
                    <div className="branchName">{item?.name}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="branchContactNoContainer">
          <div className="branchContactNo">
            If you need contact information on branches, please call +91
            9790934910
          </div>
        </div>
      </div>
      {/* <ContactUsFooter /> */}
      <Footer />
    </div>
  );
}
